<template>
  <div class='gccwaringDetail'>
    <div class='bg' id="bg" v-loading="loading">
      <p class="top-title">Report of  <span>{{ titleName }}</span> </p>
      <p class="top-title top-title-version">Version: <span>{{ vsersion }}</span></p>
      <div class="tree-box">
        <div class="tree-content" v-for="data in dataTreeList" :key="data">
          <el-tree 
            highlight-current 
            class="tree" 
            :data="data" 
            :props="defaultProps"
            accordion
            node-key="label"
            >
            <template #default="{ node }">
              <div class="node-div" @mouseenter="mouseEnter(node)" @mouseleave="mouseLeave(node)">
                <p class="node-lable">{{ node.label }} </p>
                <div class="node-img-box" v-show="node.data?.isShow" @click="showDataDialog(node, $event)">
                  <img class="node-img" src="@/assets/tishi-icon.png" />
                </div>
              </div> 
            </template>
          </el-tree>
        </div>
      </div>
      <div class="content-bg" :style="{right: tableRight, width: tableWidth}" v-show="showContentBg">
        <div class="table-box" >
          <el-table 
            class="table"
            :data="dialogDataList"
            element-loading-background="rgba(255, 255, 255, 0.8)" 
            border width="100%" fit 
            :height="tableH"
            stripe
            tooltip-effect="light" 
            :header-cell-style="{
              background: '#ECF2FE',
              borderColor: '#999999',
              color: '#383838',
              fontSize: '16px',
              fontWeight: 'bold',
              height: '50px',
            }" 
            :cell-style="{
              background: '#FFFFFF',
              borderColor: '#999999',
              fontSize: '15px',
              fontWeight: '400',
              color: '#383838',
            }"
            @row-click="clickNameDo"
            highlight-current-row>
            <el-table-column prop="name" label="Name" align="center">
              <template #default="scope">
                <div class="table-title-name" :style="{color: titleColor(scope.row)}" >{{ scope.row.name }}</div>
              </template>
            </el-table-column>
            <el-table-column prop="value" label="Sum" align="center" width="100">
              <template #default="scope">
                <div class="table-title-value" :style="{color: titleColor(scope.row)}" >{{ scope.row.value }}</div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="show-lines-bg" >
          <div class="lines-bg" v-loading="loadingLine">
            <el-scrollbar :max-height="scrollH" class="scrollbar">
              <div class="line-box" v-for="(line, index) in selectLineValuesList" :key="line">
                <p class="line-p-1"> {{ index + 1 }} </p>
                <p class="line-p-2"> {{ line }} </p>
              </div>
            </el-scrollbar>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  getQueryStatus,
  newDownLoadFile
} from "@/request/api";
import {
  getUrlData
} from "@/request/axiosApi";
import { ResourceType } from "@/ginkgo-grpc/jslang/proto/services/rbf_service_pb";
export default {
  name: 'gccwaringDetail',
  data() {
    return {
      loading: false,
      titleName: '',
      dataTreeList: [],
      dialogDataList: [],
      tableH: 500,
      tableRight: '110px',
      tableWidth: '550px',
      dataLineList: [],
      scrollH: 400,
      selectNodeData: {},
      selectLineValuesList: [],
      vsersion: "",
      showContentBg: false,
      loadingLine: true,
    }
  },
  computed: {
    titleColor() {
      return row => {
        if (row?.selected) {
          return '#0052d9'
        }
        return '#555666'
      }
    },
    valueModel() {
      return node => {
        const vModel = {}
        for (const v of node.data.values) {
          const keys = Object.keys(v.value)
          for (const key of keys) {
            const va = v.value[key]
            if (vModel[key]) {
              const v1 = vModel[key]
              vModel[key] = v1 + va
            } else {
              vModel[key] = va
            }
          }
        }
        return vModel
      }
    }
  },
  mounted() {
    const _this = this
    window.onresize = () => {
      return (() => {
        _this.loadBgLayout()
      })()
    }
  },
  methods: {
    clickNameDo(row) {
      this.showContentBg = true
      this.loadingLine = true
      this.dialogDataList.map(m => {
        m.selected = false
      })
      row.selected = true
      let valueLinesList = []
      for (const vModel of this.selectNodeData?.values) {
        const lineType = vModel?.value?.WarningTypes[row?.name]
        if (lineType) {
          const lines = vModel?.value?.WarningLines
          const li = lines.filter(line => {
            return line?.includes(row?.name)
          })
          valueLinesList = valueLinesList.concat(li)
        }
      }
      this.selectLineValuesList = valueLinesList
      this.loadBgLayout()
      this.loadingLine = false
    },
    loadBgLayout() {
      const _this = this
      this.$nextTick(() => {
        const totalH = this.dialogDataList.length * 48 + 50 + this.dialogDataList.length + 10 + 10
        const bodyW = document.body.clientWidth
        const bodyH = document.body.clientHeight
        const screenH = screen.availHeight - 400
        _this.showContentBg = bodyW > 500 
        const h = bodyH - 400
        if (h < 300) {
          _this.scrollH = 300
        } else {
          if (h > screenH) {
            _this.scrollH = screenH
          } else {
            _this.scrollH = h
          }
        }
        if (h > screenH) {
          _this.tableH = screenH
        } else {
          _this.tableH = h
        }
        if (totalH < _this.tableH) {
          _this.tableH = totalH
        }
        const bg = document.getElementById("bg");
        const wid = bg.offsetWidth
        const scapW = (bodyW - wid) / 2 + 20
        _this.tableWidth = wid / 3 * 2 - 90 + 'px'
        _this.tableRight = scapW + 'px'
      })
    },
    showDataDialog(node, event) {
      console.log("node = ", node)
      event?.stopPropagation()
      this.selectNodeData = node?.data
      this.dialogDataList = []
      this.dataLineList = []
      const vModel = {}
      for (const v of node?.data?.values) {
        const lines = v.value?.WarningLines
        if (node.data.children?.length == 0) {
          if (lines?.length > 0) {
            this.dataLineList = this.dataLineList.concat(lines)
          }
        }
        if (v.value?.WarningTypes) {
          const keys = Object.keys(v.value?.WarningTypes)
          for (const key of keys) {
            const va = v.value?.WarningTypes[key]
            if (vModel[key]) {
              const v1 = vModel[key]
              vModel[key] = v1 + va
            } else {
              vModel[key] = va
            }
          }
        }
      }
      for (const [key, v] of Object.entries(vModel)) {
        const model = {
          name: key,
          value: v,
          selected: false
        }
        this.dialogDataList.push(model)
      }
      if (this.dialogDataList?.length > 0) {
        this.clickNameDo(this.dialogDataList[0])
        this.showContentBg = true
      }
     this.loadBgLayout()
    },
    mouseEnter(node) {
      node.data.isShow = true
    },
    mouseLeave(node) {
      node.data.isShow = false
    }, 
    getClassifyData(dataArr) {
      const treeDataArray = [] 
      for (const index in dataArr) {
        let childDataList = []
        const model = dataArr[index]
        let curChild = {}
        for (const i in model.list) {
          const name = model.list[i]
          const mod = {
            label: name,
            children: [],
            values: [],
          }
          if (i == 0) {
            if (treeDataArray.length > 0) {
              let isHave = false
              for (const treeList of treeDataArray) {
                const childL = treeList.filter(ch => {
                  return ch.label == name
                })
                if (childL.length > 0) {
                  childDataList = treeList
                  isHave = true
                  break
                }
              }
              if (isHave) {
                  curChild = childDataList[0]
                  curChild.values.push(model)
              } else {
                mod.values.push(model)
                childDataList.push(mod)
                treeDataArray.push(childDataList)
                curChild = mod
              }
            } else {
              mod.values.push(model)
              childDataList.push(mod)
              treeDataArray.push(childDataList)
              curChild = mod
            }
          } else if (i >= 1) {
            const chArr = curChild?.children?.filter(ch => {
              return ch.label == name
            })
            if (i == model.list.length - 1) {
              mod.data = model
            }
            if (chArr?.length == 0) {
              mod.values.push(model)
              curChild.children.push(mod)
              curChild = mod
            } else {
              curChild = chArr[0]
              curChild.values.push(model)
            }
          } 
        }
      }
      this.dataTreeList = treeDataArray
    },
  },

  async created() {
    this.loading = true
    this.isShowLines = false
    const id = this.$route.params.id
    try {
      const queryData = await getQueryStatus(id, ResourceType.DATA)
      const metricModel = queryData.data
      for (const map of metricModel?.annotationsMap) {
        if (map[0]?.trim().toLocaleLowerCase() == "title") {
          this.titleName = map[1];
        } 
      }
      document.title = `aqua.${this.titleName}`
      const ossKey = metricModel.ossfile?.key
      const fileName = metricModel.ossfile?.originname
      const url = await newDownLoadFile(ossKey, fileName)
      const data = await getUrlData(url)
      this.vsersion = data?.EdenVersion
      const list = []     
      let warings = {}
      if (data?.Warnings) {
        warings = data.Warnings
      } else {
        warings = data
      }
      for (const [key, value] of Object.entries(warings)) {  
        if (typeof value == "object") {
          const keys = key.split("/");
          const model = {
            name: key,
            value: value,
            list: keys
          }
          list.push(model)
        }
      }
      this.getClassifyData(list)
    } catch (error) {
      console.log(error)
    }
    this.loading = false
    this.loadBgLayout()
    if (this.dataTreeList.length > 0) {
      const treeList = this.dataTreeList[0]
      if (treeList?.length > 0) {
        const data = treeList[0]
        this.showDataDialog({data: data}, null)
        if (this.dialogDataList?.length > 0) {
          this.clickNameDo(this.dialogDataList[0])
          this.showContentBg = true
        }
      }
    }
  }
}
</script>
<style lang='less' scoped>

.gccwaringDetail {
  padding: 60px 100px 20px 100px;
  border-radius: 8px;
  margin: auto;
}

.bg {
  padding: 35px 15px 10px 15px;
  background-color: #fff;
  min-height: calc(100vh - 200px);
  position: relative;
  min-width: 800px;
  max-width: 2300px;
  margin: auto;
  width: 100%;
}

.tree-box {
  width: calc(100% / 3);
  min-width: 200px;
  display: flex;
  flex-direction: column;
}

.content-bg {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  position: fixed;
  top: 150px;
  display: flex;
  flex-direction: row;
}

.table-box {
  width: calc(100% / 2 - 50px);
  min-width: 320px;
  max-width: 380px;
}

.table-title-name {
  width: 100%;
  cursor: pointer;
  font-size: 15px;
  text-align: left;
}

.table-title-value {
  font-size: 15px;
  cursor: pointer;
  width: 100%;
}

.show-lines-bg {
  height: 100%;
  width: calc(100% / 2 - 50px);
  min-width: 200px;
  max-width: 600px;
  margin-left: 10px;
}

.lines-bg {
  margin-top: 0px;
  background-color: #fff;
  box-shadow: 0px 1px 2px 1px #cbcdcf;
  border-radius: 6px;
  width: 100%;
  padding: 10px 10px;
  .line-box {
    display: flex;
    margin: 10px 0px;
    align-items: center;
    .line-p-1 {
      font-size: 14px;
    }
    .line-p-2 {
      margin-left: 5px;
      display: flex;
      text-align: left;
      font-size: 14px;
      align-items: center;
      border-radius: 4px;
      background-color: #e9f3ff;
      min-height: 46px;
      padding: 5px 8px;
      width: 100%;
      word-break:break-all;
    }
  }
}

.top-title {
  color: #000;
  font-size: 16px;
  font-weight: 500;
  padding-left: 15px;
  text-align: left;
  span {
    color: #0052d9;
    font-weight: 600;
  }
}

.top-title-version {
  margin-top: 10px;
  font-size: 14px;
}

.tree-content {
  width: 100%;
  max-width: 1100px;
  padding: 30px 0px;
}

.tree {
  width: 100%;
}

.node-div {
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  text-align: left;
  font-size: 16px;
  color: #383838;
  position: relative;
  .node-lable {
    align-items: center;
    font-size: 15px;
    font-weight: 400;
    padding-right: 10px;
  }

  .node-img-box {
    cursor: pointer;
    padding: 5px;
    display: flex;
    align-items: center;
    .node-img {
      height: 16px;
      width: 16px;
      object-fit: contain;
    }
  }
}

:deep(.el-tree .el-tree-node) {
  margin-bottom: 10px;
}

:deep(.el-tree-node) {
  position: relative;
  padding-left: 16px;
}

:deep(.el-tree .el-tree-node__content) {
  padding-left: 5px !important;
  padding-top: 0px !important;
  height: 40px !important;
}

:deep(.el-tree .el-tree-node__label) {
  width: 100% !important;
  text-align: left !important;
  height: 40px !important;
  line-height: 40px !important;
  padding: 8px !important;
}

:deep(.el-tree-node__children) {
  padding-left: 8px;
  margin-top: 8px;
}

:deep(.el-dialog) {
  border-radius: 8px;
  padding: 0px 20px 0px 20px; 
  width: 1100px !important;
  padding-bottom: 10px;
}

</style>